import { ApptRequestVerificationSummary } from '../../services/insurance/types/appt-request-verification-summary';
import CarrierSummary from "../../services/insurance/types/carrier-name";
import { PatientVerificationSummary } from "../../services/insurance/types/patient-verification-summary";
import { PracticeOnboarding } from "../../services/insurance/types/practice-onboarding";
import { Provider } from "../../services/insurance/types/provider";
import { VerificationResponse } from "../../services/insurance/types/verification-response";
import { VerificationSummary } from "../../services/insurance/types/verification-summary";

export interface IInsuranceApiContext {
    status: Record<InsuranceApiOperation, ApiOperationStatus>,
    getCarrierSummaries: (locationId: number) => Promise<CarrierSummary[]>,
    getPracticeOnboarding: (locationId: number) => Promise<PracticeOnboarding | null>,
    getProviders: (locationId: number) => Promise<Provider[]>,
    runVerification: (locationId: number, idPatient: number, idProvider: number, idCarrierName?: number) => Promise<boolean>,
    selfPayVerification: (locationId: number, idPatient: number, idProvider: number) => Promise<boolean>,
    SelfPayApptRequest: (apptRequestId: number, locationId: number, idProvider: number) => Promise<boolean>,
    manualVerification: (locationId: number, idPatient: number, idProvider: number) => Promise<boolean>,
    manuallyVerifyApptRequest: (apptRequestId: number, locationId: number, idProvider: number) => Promise<boolean>,
    getVerificationDocumentUrl: (locationId: number, verificationRequestId: number) => Promise<string | null>,
    getPatientVerificationSummaries: (patientIds: number[], locationId: number) => Promise<PatientVerificationSummary[]>,
    getAppointmentRequestVerificationSummaries: (appointmentRequestIds: number[], locationId: number) => Promise<ApptRequestVerificationSummary[]>,
    getAppointmentRequestVerificationSummary: (appointmentRequestIds: number, locationId: number) => Promise<ApptRequestVerificationSummary>,
    getVerificationResponse: (locationId: number, verificationRequestId: number) => Promise<VerificationResponse | null>,
    getVerificationSummary: (locationId: number, verificationRequestId: number) => Promise<VerificationSummary | null>
}

export interface ApiOperationStatus {
    isRunning: boolean;
    error: boolean;
}

export enum InsuranceApiOperation {
    GetCarrierSummaries = "getCarrierSummaries",
    GetPracticeOnboarding = "getPracticeOnboarding",
    GetProviders = "getProviders",
    RunVerification = "runVerification",
    SelfPayVerification = "selfPayVerification",
    SelfPayApptRequest = "SelfPayApptRequest",
    ManualVerification = "manualVerification",
    ManuallyVerifyApptRequest = "ManuallyVerifyApptRequest",
    GetVerificationDocumentUrl = "getVerificationDocumentUrl",
    GetPatientVerificationSummaries = "getPatientVerificationSummaries",
    GetAppointmentRequestVerificationSummaries = "getAppointmentRequestVerificationSummaries",
    GetAppointmentRequestVerificationSummary = "getAppointmentRequestVerificationSummary",
    GetVerificationResponse = "getVerificationResponse",
    GetVerificationSummary = "getVerifcationSummary",
    GetKaynDashboardUrl = "getKaynDashboardUrl",
}